export default "__VITE_ASSET__2EGmJ9fK__"